import LocalSearchHistory from "./localSearchHistory"
import "./jquery.autocomplete";

$(function () {
    var $SearchTerm = $('#SearchTerm');
    var $MainSearchTerm = $('#MainSearchTerm');

    new LocalSearchHistory($SearchTerm, 2);

    $SearchTerm.autocomplete({
        serviceUrl: '/suggest',
        minChars: 2,
        deferRequestBy: 50,
        noCache: true,
        autoSelectFirst: false,
        triggerSelectOnValidInput: false,
        appendTo: '#SearchSuggestContainer',
        onSelect: function (suggestion) {
            var $Search = $('#Search');
            if (typeof suggestion.type != "undefined" && suggestion.type === "string") {
                //Local Search History by String
                $SearchTerm.val(suggestion.value);
                $Search.submit();
            } else {
                if (suggestion.data.Path !== null) {
                    window.location = suggestion.data.Path;
                    window.searchHistory.addSearchEntryFromSuggest(suggestion);
                } else {
                    window.searchHistory.addSearchEntryFromString($SearchTerm.val());
                    $Search.submit();
                }
            }
        }
    });

    if ($MainSearchTerm.length) {
        window.mainSearchHistory = new LocalSearchHistory($MainSearchTerm, 2);

        $MainSearchTerm.autocomplete({
            serviceUrl: '/suggest',
            minChars: 2,
            deferRequestBy: 50,
            noCache: true,
            autoSelectFirst: false,
            triggerSelectOnValidInput: false,
            appendTo: '#MainSearchSuggestContainer',
            onSelect: function (suggestion) {
                var $MainSearch = $('#MainSearch');
                if (typeof suggestion.type != "undefined" && suggestion.type === "string") {
                    //Local Search History by String
                    $MainSearchTerm.val(suggestion.value);
                    $MainSearch.submit();
                } else {
                    if (suggestion.data.Path !== null) {
                        window.location = suggestion.data.Path;
                        window.searchHistory.addSearchEntryFromSuggest(suggestion);
                    } else {
                        window.searchHistory.addSearchEntryFromString($MainSearchTerm.val());
                        $MainSearch.submit();
                    }
                }
            }
        });
    }


});
//# sourceMappingURL=init_autocomplete.js.map
